import React, { useState, useEffect , useRef } from "react";
import dots from "../assets/images/dots.svg";
import { Modal } from "react-bootstrap";
import { Link, useParams, useLocation, useNavigate  } from "react-router-dom";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import http from "../services/http";
import Dropdown from "react-bootstrap/Dropdown";
import { SpinnerCircular } from "spinners-react";
import ReactPaginate from "react-paginate";
import arrowleft from "../assets/images/arrow-left.png";
import image1 from "../assets/images/copy.svg"

export default function Analysts() {
  const [showModal, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showModals, setShows] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [isDeactivate, setisDeactivate] = useState(0);
  const handleCloses = () => setShows(false);
  const handleShows = (id, is_deactivated) => {
    setisDeactivate(is_deactivated);
    setSelectedId(id);
    setShows(true);
  };
  const [key, setKey] = useState("home");
  const token = localStorage.getItem("xAuthToken");
  const [analyst, setAnalyst] = useState([]);
  const [available, setAvailable] = useState([]);
  const [unavailable, setUnAvailable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploadSpin, setUploadSpin] = useState(false);
  const [toggle, setToggle] = useState(true);
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [analystEmail, setAnalystEmail] = useState([])
  const [message, setMessage] = useState("");
  const [inputValue, setInputValue] = useState('');
  const [validationMessage, setValidationMessage] = useState('');

  useEffect(() => {
    Analyst();
  }, []);

  const Analyst = async () => {
    setLoading(true);

    http

      .get(`public/admin/analyst?token=${token}`)
      .then((res) => {
        console.log("analyst----->", res.data);
        setAnalyst(res.data);
        setLastPageNumber(res.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.length / usersPerPage));
        setLoading(false);
        setAnalystEmail(res.data.map(analyst => analyst.email))
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const Deactivate = async () => {
    setUploadSpin(true);
    if (isDeactivate === 0) {
      http
        .put(`api/admin/analyst/deactivate/${selectedId}?token=${token}`)
        .then((res) => {
          console.log("deactivate----", res.status);
          setUploadSpin(false);

          if (res.status === 200) {
            handleCloses();

            // const remData = analyst.filter(function (obj) {
            //   return obj.id !== selectedId;
            // });
            // const availableRemData = available.filter(function (obj) {
            //   return obj.id !== selectedId;
            // });
            // const unavailableRemData = unavailable.filter(function (obj) {
            //   return obj.id !== selectedId;
            // });
            // setAnalyst(remData);
            // setAvailable(availableRemData);
            // setUnAvailable(unavailableRemData);
            Analyst();
            setSelectedId(0);
            setMessage(res.data.message);
          }
        })
        .catch((error) => {
          console.log("error", error);
          setUploadSpin(false);
        });
    } else {
      http
        .put(`api/admin/analyst/activate/${selectedId}?token=${token}`)
        .then((res) => {
          console.log("activate----", res.status);
          setUploadSpin(false);

          if (res.status === 200) {
            handleCloses();

            const remData = analyst.filter(function (obj) {
              return obj.id !== selectedId;
            });
            const availableRemData = available.filter(function (obj) {
              return obj.id !== selectedId;
            });
            const unavailableRemData = unavailable.filter(function (obj) {
              return obj.id !== selectedId;
            });
            setAnalyst(remData);
            setAvailable(availableRemData);
            setUnAvailable(unavailableRemData);
            setSelectedId(0);
            setMessage(res.data.message);
          }
        })
        .catch((error) => {
          console.log("error", error);
          setUploadSpin(false);
        });
    }
  };

  const InProgress = (k) => {
    setKey(k);
    switch (k) {
      case "home":
        setLoading(true);

        http
          .get(`public/admin/analyst?token=${token}`)
          .then((res) => {
            console.log("analyst", res.data);
            setAnalyst(res.data);
            setLastPageNumber(res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);

            console.log("error==>", error);
          });
        break;
      case "Completed":
        setLoading(true);

        http
          .get(`public/admin/analyst/unavailable?token=${token}`)
          .then((res) => {
            console.log("unavailable=====>", res.data);
            setUnAvailable(res.data);
            setLastPageNumber(res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
        break;
      default:
        setLoading(true);

        http
          .get(`public/admin/analyst/available?token=${token}`)
          .then((res) => {
            console.log("available=====>", res.data);
            setAvailable(res.data);
            setLastPageNumber(res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
            // setPageNumber(res.data.length);
          })
          .catch((error) => {
            console.log("error==>", error);
            setLoading(false);
          });
        break;
    }
  };

  const [pageNumber, setPageNumber] = useState(0);

  const usersPerPage = 7;
  const pagesVisited = pageNumber * usersPerPage;

  const pageCountAnalyst = Math.ceil(analyst.length / usersPerPage);
  const pageCountAvailable = Math.ceil(available.length / usersPerPage);
  const pageCountUnavailable = Math.ceil(unavailable.length / usersPerPage);
  // const perPageAnalyst = analyst.length / usersPerPage;
  const listAnalyst = analyst.length;
  const listAvailable = available.length;
  const listUnavailable = unavailable.length;
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const inputRef = useRef(null);
  const navigate = useNavigate();

  const handleImageClick = () => {
    if (inputRef.current) {
      navigator.clipboard
        .writeText(inputRef.current.value)
        .then(() => {
          console.log("text copied");
          setShow(true);
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
  };

    const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.length < 6) {
      setValidationMessage('Input must be at least 6 characters long.');
    } else {
      setValidationMessage('');
    }
  };

  const handleSelectAnalysts = () => {
    if(inputRef.current.value) navigate(`/analystsCheckBox?text=${inputRef.current.value}`);
  };

  const handleSendToAll = async () => {
    const inputValue = inputRef.current.value;
    try {
      if (inputValue.length > 6) {
        http.post(`public/admin/analyst/sendEmailToAll?token=${token}`, {
          analystEmail,
          inputValue,
        });
        setMessage("Message sent to all analysts!");
      } else {
        setMessage("Please write something");
      }
      if(inputValue.length > 6) {setShow(false);}
    } catch (error) {
      console.error("Error sending messages:", error);
      alert("Failed to send messages.");
    }
  };
  
  return (
    <>
      <div className="wrapper">
        {toggle && <Nav />}
        <div id="content">
          <header>
            <div className="dashboard_header">
              <div className="left-side d-flex ">
                {" "}
                {/*  <button
                  type="button"
                  onClick={() => setToggle(!toggle)}
                  className="btn btn-link bt_none"
                >
                  {" "}
                  <img src={arrowleft} className="img-fluid" />{" "}
                </button> */}
                <h1>Analyst</h1>
              </div>
              <DropdownRight />
            </div>
          </header>
          <div className="dashbord_content">
            <div className="analysts-wraper-head">
              <div className="personal_and_bank_info Analysts_tabs ">
                <div className="">
                 <div
                  className="map_btn tabs_google_meet"
                  style={{
                    // marginLeft: 750,
                    // width: 300,
                    // height: 100,
                    // marginBottom: -120,
                  }}
                >
                  {" "}
                  <button
                    style={{ marginTop: 40, marginLeft: 30 }}
                    onClick={handleShow}
                    className="them_btn"
                    type="button"
                    data-toggle="modal"
                    data-target="#Google_Meet"
                  >
                    Google Meet
                  </button>{" "}
                  
                </div>
                <Tabs
                  activeKey={key}
                  onSelect={(k) => InProgress(k)}
                  style={{
                    alignItems: "center",
                    width: 470,
                    borderRadius: 5,
                    marginTop: 50,
                    backgroundColor: "#f6f6f6",
                    padding: 10,
                  }}
                  defaultActiveKey="profile"
                  id="uncontrolled-tab-example"
                  className="mb-3 nav nav-pills border-bottom-0"
                >
                  <Tab
                    eventKey="home"
                    title="All"
                    style={{ marginTop: 10 }}
                    // onSelect={EvoOrders()}
                  >
                    <div className="table_vedio_upload dashbord_table mb_30 mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            <th scope="col" className="  pl_25">
                              Analyst ID
                            </th>
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Email ID
                            </th>
                            <th scope="col" className=" ">
                              Cell Number
                            </th>
                            <th scope="col" className=" ">
                              Level
                            </th>
                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="  ">
                              {" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <div
                              style={{
                                position: "absolute",
                                marginTop: 250,
                                backgroundColor: "#ffffffc2",
                                marginLeft: 580,

                                backgroundBlendMode: "overlay",
                                zIndex: 100,
                              }}
                            >
                              <SpinnerCircular size="15%" />
                            </div>
                          ) : (
                            <>
                              {analyst
                                .slice(
                                  pagesVisited,
                                  pagesVisited + usersPerPage
                                )
                                ?.map((item) => (
                                  <tr data-id={item.id}>
                                    <td className="pl_25">{item.id} </td>
                                    <td>
                                      {" "}
                                      {item.firstname} {item.lastname}
                                    </td>
                                    <td className="email_ids">{item.email}</td>
                                    <td>{item.phone}</td>
                                    <td>{item.level ? item.level : "Beginner"}</td>

                                    <td>
                                      <div className="btn_wraper d-flex justify-content-center  ">
                                        <div className="btn_Subscribed">
                                          {" "}
                                          <button
                                            type="button"
                                            className={
                                              "" +
                                              (item.is_available === 1
                                                ? "them_btn_Subscribed"
                                                : "them_btn_Unsubscribed")
                                            }
                                          >
                                            {item.is_available === 1
                                              ? "Available"
                                              : "UnAvailable"}
                                          </button>{" "}
                                        </div>
                                      </div>
                                    </td>
                                    <td className="text-center">
                                      <div className="dropdown wraper_btn">
                                        <Dropdown>
                                          <Dropdown.Toggle
                                            className="btn dropdown-toggle"
                                            variant="success"
                                            id="dropdown-basic"
                                          >
                                            <img
                                              src={dots}
                                              className="img-fulid  "
                                            />
                                            <span className="caret"></span>
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu
                                            as="ul"
                                            className="dropul"
                                          >
                                            <Dropdown.Item as="li">
                                              <Link
                                                to="/analystsIntermediate"
                                                state={{
                                                  id: item.id,
                                                  name: `${item.firstname} ${item.lastname}`,
                                                  isdeactivate:
                                                    item.is_deactivated,
                                                }}
                                                className="link"
                                              >
                                                View Profile
                                              </Link>
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                              to="#/action-2"
                                              as="li"
                                              onClick={() =>
                                                handleShows(
                                                  item.id,
                                                  item.is_deactivated
                                                )
                                              }
                                            >
                                              {item.is_deactivated === 1
                                                ? "Activate"
                                                : " Deactivate"}
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </>
                          )}
                        </tbody>
                      </table>
                      <div className="pagination">
                        <div className="paginateText">
                          <p className="text-table-show">
                            {" "}
                            Showing{" "}
                            {
                              analyst.slice(
                                pagesVisited,
                                pagesVisited + usersPerPage
                              ).length
                            }{" "}
                            out of {listAnalyst} entries
                          </p>
                        </div>
                        <div className="reactPaginate">
                          <ReactPaginate
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            pageCount={pageCountAnalyst}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                          />
                        </div>
                      </div>
                    </div>
                  </Tab>

                  <Tab
                    onSelect={InProgress}
                    eventKey="Progress"
                    title="Available"
                    style={{ marginTop: 40 }}
                  >
                    <div className="table_vedio_upload dashbord_table     mb_30  mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            <th scope="col" className="  pl_25">
                              Analyst ID
                            </th>
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Email ID
                            </th>
                            <th scope="col" className=" ">
                              Cell Number
                            </th>

                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="  ">
                              {" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {available
                            .slice(pagesVisited, pagesVisited + usersPerPage)
                            ?.map((item) => (
                              <tr>
                                <td className="pl_25">{item.id} </td>
                                <td>
                                  {" "}
                                  {item.firstname} {item.lastname}
                                </td>
                                <td style={{ wordBreak: "break-all" }}>
                                  {item.email}
                                </td>
                                <td>{item.phone}</td>

                                <td>
                                  <div className="btn_wraper d-flex justify-content-center  ">
                                    <div className="btn_Subscribed">
                                      {" "}
                                      <button
                                        type="button"
                                        className={
                                          "" +
                                          (item.is_available === 1
                                            ? "them_btn_Subscribed"
                                            : "them_btn_Unsubscribed")
                                        }
                                      >
                                        {item.is_available === 1
                                          ? "Available"
                                          : "UnAvailable"}
                                      </button>{" "}
                                    </div>
                                  </div>
                                </td>
                                <td className="text-center">
                                  <div className="dropdown wraper_btn">
                                    <Dropdown>
                                      <Dropdown.Toggle
                                        className="btn dropdown-toggle"
                                        variant="success"
                                        id="dropdown-basic"
                                      >
                                        <img
                                          src={dots}
                                          className="img-fulid  "
                                        />
                                        <span className="caret"></span>
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu as="ul" className="dropul">
                                        <Dropdown.Item to="#/action-1" as="li">
                                          <Link
                                            to="/analystsIntermediate"
                                            state={{
                                              id: item.id,
                                              name: `${item.firstname} ${item.lastname}`,
                                              isdeactivate: item.is_deactivated,
                                            }}
                                            className="link"
                                          >
                                            View Profile
                                          </Link>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          to="#/action-2"
                                          as="li"
                                          onClick={() =>
                                            handleShows(
                                              item.id,
                                              item.is_deactivated
                                            )
                                          }
                                        >
                                          {item.is_deactivated === 1
                                            ? "Activate"
                                            : " Deactivate"}
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      <div className="pagination">
                        <div className="paginateText">
                          <p className="text-table-show">
                            {" "}
                            Showing{" "}
                            {
                              available.slice(
                                pagesVisited,
                                pagesVisited + usersPerPage
                              ).length
                            }{" "}
                            out of {listAvailable} entries
                          </p>
                        </div>
                        <div className="reactPaginate">
                          <ReactPaginate
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            pageCount={pageCountAvailable}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                          />
                        </div>
                      </div>
                    </div>
                  </Tab>
                  <Tab
                    eventKey="Completed"
                    title="Unavailable"
                    style={{ marginTop: 40 }}
                  >
                    <div className="table_vedio_upload dashbord_table     mb_30 mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            <th scope="col" className="  pl_25">
                              Analyst ID
                            </th>
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Email ID
                            </th>
                            <th scope="col" className=" ">
                              Cell Number
                            </th>

                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="  ">
                              {" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {unavailable
                            .slice(pagesVisited, pagesVisited + usersPerPage)
                            ?.map((item) => (
                              <tr>
                                <td className="pl_25">{item.id} </td>
                                <td>
                                  {" "}
                                  {item.firstname} {item.lastname}
                                </td>
                                <td style={{ wordBreak: "break-all" }}>
                                  {item.email}
                                </td>
                                <td>{item.phone}</td>

                                <td>
                                  <div className="btn_wraper d-flex justify-content-center  ">
                                    <div className="btn_Subscribed">
                                      {" "}
                                      <button
                                        type="button"
                                        className={
                                          "" +
                                          (item.is_available === 1
                                            ? "them_btn_Subscribed"
                                            : "them_btn_Unsubscribed")
                                        }
                                      >
                                        {item.is_available === 1
                                          ? "Available"
                                          : "UnAvailable"}
                                      </button>{" "}
                                    </div>
                                  </div>
                                </td>
                                <td className="text-center">
                                  <div className="dropdown wraper_btn">
                                    <Dropdown>
                                      <Dropdown.Toggle
                                        className="btn dropdown-toggle"
                                        variant="success"
                                        id="dropdown-basic"
                                      >
                                        <img
                                          src={dots}
                                          className="img-fulid  "
                                        />
                                        <span className="caret"></span>
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu as="ul" className="dropul">
                                        <Dropdown.Item to="#/action-1" as="li">
                                          <Link
                                            to="/analystsIntermediate"
                                            state={{
                                              id: item.id,
                                              name: `${item.firstname} ${item.lastname}`,
                                              isdeactivate: item.is_deactivated,
                                            }}
                                            className="link"
                                          >
                                            View Profile
                                          </Link>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          to="#/action-2"
                                          as="li"
                                          onClick={() =>
                                            handleShows(
                                              item.id,
                                              item.is_deactivated
                                            )
                                          }
                                        >
                                          {item.is_deactivated === 1
                                            ? "Activate"
                                            : " Deactivate"}
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      <div className="pagination">
                        <div className="paginateText">
                          <p className="text-table-show">
                            {" "}
                            Showing{" "}
                            {
                              unavailable.slice(
                                pagesVisited,
                                pagesVisited + usersPerPage
                              ).length
                            }{" "}
                            out of {listUnavailable} entries
                          </p>
                        </div>
                        <div className="reactPaginate">
                          <ReactPaginate
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            pageCount={pageCountUnavailable}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                          />
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
                </div>
              </div>
              <div className="google_meet_popup">
              <Modal show={showModal} onHide={handleClose} className="google_meet_popup" >
                <Modal.Header closeButton>
                  <Modal.Title>Google Meet</Modal.Title>
                  <button
                    onClick={handleClose}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    {" "}
                    <span aria-hidden="true">&times;</span>{" "}
                  </button>
                </Modal.Header>
                <Modal.Body>
                <div class="modal-body">
                <div class="raing_star">
                    <p>
                    Lorem ipsum dolor sit amet, consectetur adiet cing elit. nun
                    c non risus condiment lobortittyr at, ef sollicitudin risus.{" "}
                  </p>
                  <div
                    class="form-group icon mt-3 w-100"

                    // style="width:100%"
                  >
                    {" "}
                    <input
                      type="text"
                      class="form-control input_field"
                      placeholder="Wefdhbwexn9wduj3wjskd932"
                      ref={inputRef}
                      value={inputValue}
                      onChange={handleInputChange}
                    />
                     {validationMessage && <p style={{ color: 'red' }}>{validationMessage}</p>}
                    <div class="img_icon">
                        <img src={image1} alt="copy" onClick={handleImageClick} />{" "}
                    </div>
                  </div>
                </div>
                <div class="modal-footer border-top-0 modal_footer_buttons">
                  {" "}
                  <button type="button" class="them_btn_ouline sendToAll" onClick={handleSendToAll}>
                    Send to all
                  </button>{" "}
                  <button type="button" class="them_btn " onClick={handleSelectAnalysts}>
                    Select analysts
                  </button>{" "}
                </div>
              </div>
                  {/* <div className="modal-body">
                    <div className="row mt-3">
                      <div className="col-12 Edit_Setting">
                        <div className="form-group icon  ">
                          <select
                            name=""
                            className="form-control custom_input w-100"
                          >
                            <option value="">Select Team</option>
                          </select>
                          <div className="img_icon">
                            {" "}
                            <img src="assets/images/dropdown.png" alt="" />{" "}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 Edit_Setting">
                        <div className="form-group icon  ">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Type Analyst Name"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer border-top-0">
                      {" "}
                      <button type="button" className="them_btn_ouline ">
                        Cancel
                      </button>{" "}
                      <button type="button" className="them_btn ">
                        Search
                      </button>{" "}
                    </div>
                  </div> */}
                </Modal.Body>
              </Modal>
              </div>

              <Modal
                className="starrating"
                show={showModals}
                onHide={handleCloses}
              >
                <Modal.Header>
                  <Modal.Title as="h5">Are you sure?</Modal.Title>
                  <button
                    onClick={handleCloses}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    {" "}
                    <span aria-hidden="true">&times;</span>{" "}
                  </button>
                </Modal.Header>
                <Modal.Body>
                  <div class="raing_star">
                    <p>Are you sure you want to perform this action?</p>
                  </div>
                  <div className="modal-footer border-top-0">
                    <button
                      onClick={handleCloses}
                      type="button"
                      className=" them_btn_ouline  "
                    >
                      Cancel
                    </button>
                    <button
                      onClick={Deactivate}
                      type="button"
                      className="them_btn1 "
                      data-toggle="modal"
                      data-target="#new_team_add_yes"
                    >
                      {uploadSpin ? <SpinnerCircular /> : " YES"}
                    </button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
